import {
	LINK_PATIENTS_TO_CLINIC_REQUEST,
	LINK_PATIENTS_TO_CLINIC_SUCCESS,
	LINK_PATIENTS_TO_CLINIC_FAILURE
} from '../../../constants'

const initialState = {
	loading: false,
	data: null,
	getClinicData: null,
	error: null,
};

const linkPatientsToClinicReducer = (state = initialState, action) => {
	switch (action.type) {
		case LINK_PATIENTS_TO_CLINIC_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case LINK_PATIENTS_TO_CLINIC_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case LINK_PATIENTS_TO_CLINIC_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default linkPatientsToClinicReducer